import { ConfigProvider } from 'antd';
import React from 'react';

import * as Style from './TextArea.style';

interface Props {
  rows?: number;
  placeholder?: string;
  style?: React.CSSProperties;
}

const TextArea = ({ rows = 4, placeholder, ...rest }: Props) => {
  return (
    <ConfigProvider
      theme={{
        cssVar: true,
        hashed: false,
        token: {
          borderRadius: 0,
          colorBorder: '#0e2a27',
          colorBgBase: '#ffffff00',
        },
        components: {
          Input: {
            inputFontSize: 32,
            activeBorderColor: '#0e2a27',
          },
        },
      }}
    >
      <Style.TextArea
        autoSize={{ minRows: 1, maxRows: rows }}
        placeholder={placeholder}
        variant="underlined"
        style={{ resize: 'none' }}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default TextArea;
